import React from 'react';
import { motion } from 'framer-motion';
import { Wrench, Cpu, Monitor, HardHat } from 'lucide-react';
const orientations = [{
  title: 'ELECTROMECÁNICA',
  color: 'border-t-accent-orange',
  iconColor: 'text-accent-orange',
  bgColor: 'bg-accent-orange/10',
  icon: <Wrench className="w-8 h-8" data-id="element-113" />,
  description: 'Corrosión, lubricantes, polímeros y termodinámica aplicada.'
}, {
  title: 'ELECTRÓNICA',
  color: 'border-t-accent-red',
  iconColor: 'text-accent-red',
  bgColor: 'bg-accent-red/10',
  icon: <Cpu className="w-8 h-8" data-id="element-114" />,
  description: 'Semiconductores, celdas galvánicas, litio y química de circuitos.'
}, {
  title: 'INFORMÁTICA',
  color: 'border-t-accent-cyan',
  iconColor: 'text-accent-cyan',
  bgColor: 'bg-accent-cyan/10',
  icon: <Monitor className="w-8 h-8" data-id="element-115" />,
  description: 'Química de componentes, e-waste, baterías y eficiencia energética.'
}, {
  title: 'CONSTRUCCIONES',
  color: 'border-t-accent-yellow',
  iconColor: 'text-accent-yellow',
  bgColor: 'bg-accent-yellow/10',
  icon: <HardHat className="w-8 h-8" data-id="element-116" />,
  description: 'Química del cemento, hormigón, aditivos y suelos.'
}];
export function Orientations() {
  return <section className="py-6 md:py-14 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-117">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-6" data-id="element-118">
        {orientations.map((item, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.1
      }} className={`bg-primary-card rounded-xl p-4 md:p-6 border-t-4 ${item.color} border-x border-b border-primary-card hover:-translate-y-1 transition-transform duration-300`} data-id="element-119">
            <div className={`w-12 h-12 md:w-14 md:h-14 rounded-2xl ${item.bgColor} ${item.iconColor} flex items-center justify-center mb-3 md:mb-4`} data-id="element-120">
              {item.icon}
            </div>
            <h3 className="text-lg md:text-xl font-bold mb-2 md:mb-3 tracking-wide" data-id="element-121">
              {item.title}
            </h3>
            <p className="text-text-muted leading-relaxed" data-id="element-122">
              {item.description}
            </p>
          </motion.div>)}
      </div>
    </section>;
}